import axios from "axios";
import { apiGet, apiPost } from "./apiService";

const API_BASE = import.meta.env.VITE_API_BASE_URL;
export const signatureservice = {
  //Form submission for create signature
  createsignature(payload: any) {
    //return axios.post(`${API_BASE}/signature/createSignature`, payload);
    return apiPost(`Signature/createsignature`, payload);
  },

  updatesignature(payload: any) {
    return apiPost(`Signature/updatesignature`, payload);
    //return axios.post(`${API_BASE}/signature/updatesignature`, payload);
  },

  getSignatureById(id: any) {
    //return axios.get(`${API_BASE}/signature/getsignaturebyId/${id}`);
    return apiGet<any>(`Signature/getsignaturebyid/${id}`);
  },

getDetailByLanId(id: any) {
  const isBCS = API_BASE.toLowerCase().includes("/bcs/");
  const safeId = isBCS
    ? encodeURIComponent(id)
    : id; 
  return apiGet<any>(`Signature/getdetailsbylanid/${safeId}`);
},
  
  getUserByLanId(id: any) {
    //return axios.get(`${API_BASE}/signature/getuserdetailbylanid/${id}`);
    return apiGet<any>(`Signature/getuserdetailbylanid/${id}`);
  },

  //Form submission for create stamp
  createstamp(payload: any) {
    //return axios.post(`${API_BASE}/signature/createStamp`, payload);
    return apiPost(`Signature/createstamp`, payload);
  }
}